import { Controller } from 'stimulus';

class ModalController extends Controller {
  connect() {
    $(this.modalTarget).on('hidden.bs.modal', () => {
      $(this.bodyTarget).html('');
    });

    $(this.modalTarget).on('shown.bs.modal', () => this.setSlickPosition());
  }

  disconnect() {
    $(this.bodyTarget).find('[data-controller="slider"]').each((i, slider) => {
      $(slider).slick('unslick');
    });
  }

  onTogglerClick(e) {
    this.modelType = e.currentTarget.dataset.modelType;
    this.modelId = e.currentTarget.dataset.modelId;

    this.fetchData()
      .then((res) => this.addDataToModalBody(res.data))
      .then(this.openModal());
  }

  fetchData() {
    return $.ajax({
      method: 'POST',
      url: window.app.api.modal,
      dataType: 'json',
      data: {
        model_type: this.modelType,
        model_id: this.modelId,
      },
    });
  }

  addDataToModalBody(data) {
    $(this.bodyTarget).html(data);

    setTimeout(() => this.setSlickPosition(), 1000);
  }

  setSlickPosition() {
    $(this.bodyTarget).find('[data-controller="slider"]').each((i, slider) => {
      $(slider).slick('setPosition');
    });
  }

  openModal() {
    $(this.modalTarget).modal('show');
  }
}

ModalController.targets = [
  'modal',
  'body',
];

export default ModalController;
